const messages: Record<string, string> = {
	'loader.loading': 'Loading data ...',
	'loader.error': 'Your process could not be loaded. Please try again later...',
	'connectionError.title': 'Connection error',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'mainError.tryAgain': 'Try again',
	'landing.headline.policyCheck': 'Welcome',
	'landing.paragraph': 'You are three steps away from finishing the process',
	'landing.stepDescription.fourAdditionalPictures': 'Upload pictures',
	'landing.stepDescription.fourDiagonalPerspectives': 'Take the required pictures',
	'landing.stepDescription.feedback': 'Give us your feedback',
	'landing.termsAndConditionsLink': 'Accept the terms and conditions',
	'landing.termsAndConditionsLinkDescription':
		'Before starting the inspection of your vehicle, check that:',
	'landing.additional-informations-section.title':
		'Before starting the inspection of your vehicle, check that:',
	'landing.additional-informations-section.text':
		'<ul>' +
		'<li>You are in a place with good light and mobile network</li>' +
		'<li>The vehicle is accessible from all angles and all side windows are closed</li>' +
		'</ul>',

	'dataPrivacyModal.headline': 'Accept the terms and conditions',
	'button.start': 'Start',
	'button.accept': 'Accept',
	'button.back': 'Back',
	'button.close': 'Close',
	'landing.aboutPolicyCheck': 'What is PolicyCheck?',
	'tutorialModal.headline.first.policyCheck': 'What is behind PolicyCheck?',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck is a quick vehicle inspection. The inspection process consists of 8 simple steps.',
	'chooseLang.headline': 'Choose your preferred language',

	'vehicleImages.overviewPhotos': 'Vehicle overview',
	'vehicleImages.overviewPhotos.subtitle': 'Photograph vehicle',
	'vehicleImages.description':
		'Photograph vehicle diagonally front left and right, rear left and right. The license plate must be visible in all pictures',
	'editPhoto.edit': 'Change',
	'button.next': 'Next',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Exemplary photo',

	'imageRecognitionMismatchModal.headline': 'Are you sure you added the right photo ?',
	'button.continue': 'Continue',
	'button.backchangeImage': 'Change image',

	'fourPerspectivesExampleModal.headline.first': 'Vehicle overview photos - an example',
	'fourPerspectivesExampleModal.button.close': 'Close',

	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Photo of the front right diagonal',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Photo of the rear right diagonal',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Photo of the rear left diagonal',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Photo of the front left diagonal',

	'button.changeImage': 'Change the photo',
	'button.deleteImage': 'Delete the photo',

	'completeVehicleImagesModal.description': 'Please add the following information',
	'completeVehicleImagesModal.headline': 'Hint',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Photo of the vehicle front left',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Photo of the vehicle rear right',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Photo of the vehicle front right',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Photo of the vehicle rear left',

	'feedback.headline.policyCheck': 'Pictures received successfully!',
	'feedback.rating.policyCheck':
		'With how many stars would you rank your experience with the app, being 5 the best score?',
	'feedback.yourOpinion': 'Comments?',
	'feedback.button.send': 'Submit',

	'dashboardMileage.paragraph.first': 'Enter the vehicle mileage',
	'fourAdditionalPictures.windshield.description':
		"Please take a detailed photo of your vehicle's front windshield",
	'dashboardMileage.dashboard.paragraph':
		'Take a photo of the vehicle dashboard with fully visible mileage. If your vehicle has electronic displays, please turn them on',

	'thanks.headline.first': 'We appreciate your feedback!',
	'thanks.paragraph.first': 'Thank you for trusting in Allianz',

	'tutorialModal.paragraph.second': ' ',

	'waitForAudit.thankYou': 'We appreciate your feedback!',
	'waitForAudit.description.damageFound': 'Thank you for trusting in Allianz Direct',
	'waitForAudit.description.damageNotFound': 'Thank you for trusting in Allianz Direct',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp.',
};

export default messages;
